
import { getReportLang } from "../generales/get_lang.js";
import { ValidateEmail } from "../generales/helpers.js";
import { forgotPassword } from "../api/api.js";

import { alta_reserva_localstorage } from "../api/api.js";

function LANG() {
  return getReportLang();
}


export function alertas({
  type = "info",        // info | success | warning | error
  title = "Notice",
  message = "",
  buttonText = "OK",
  onConfirm = null,
  redirect = null
}) {

  // eliminar popup previo
  const old = document.getElementById("iosPopupOverlay");
  if (old) old.remove();

  // colores por tipo
  const COLORS = {
    info:    "#007AFF",
    success: "#34C759",
    warning: "#FF9F0A",
    error:   "#FF3B30"
  };

  const BTN_COLOR = COLORS[type] || COLORS.info;

  // estilos (solo se insertan una vez)
  if (!document.getElementById("iosAlertStyle")) {
    const style = document.createElement("style");
    style.id = "iosAlertStyle";
    style.innerHTML = `
      #iosPopupOverlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        backdrop-filter: blur(6px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2147483647;
        animation: fadeIn 0.2s ease-out;
      }

      #iosPopupCard {
        position: relative;
        background: #fff;
        width: 85%;
        max-width: 360px;
        padding: 26px 22px 22px;
        border-radius: 18px;
        text-align: center;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto;
        animation: slideUp 0.25s ease-out;
      }

      #iosPopupCard h2 {
        margin: 0 0 10px;
        font-size: 20px;
        font-weight: 600;
        color: #111;
      }

      #iosPopupCard p {
        font-size: 16px;
        color: #444;
        line-height: 1.35;
      }

      .iosBtn {
        margin-top: 18px;
        color: #fff;
        padding: 12px;
        width: 100%;
        border-radius: 12px;
        border: none;
        font-size: 16px;
        cursor: pointer;
        font-weight: 500;
      }

      .iosCloseBtn {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(0,0,0,0.08);
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
        color: #333;
        user-select: none;
      }

      .iosCloseBtn:hover {
        background: rgba(0,0,0,0.15);
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from { transform: translateY(40px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // overlay
  const overlay = document.createElement("div");
  overlay.id = "iosPopupOverlay";

  // card
  const card = document.createElement("div");
  card.id = "iosPopupCard";

  // close
  const closeBtn = document.createElement("div");
  closeBtn.className = "iosCloseBtn";
  closeBtn.innerHTML = "✕";
  closeBtn.onclick = () => overlay.remove();

  // content
  card.innerHTML = `
    <h2>${title}</h2>
    <p>${message}</p>
  `;

  // button
  const button = document.createElement("button");
  button.className = "iosBtn";
  button.style.background = BTN_COLOR;
  button.innerText = buttonText;

  button.onclick = () => {
      overlay.remove();

      if (typeof onConfirm === "function") {
        onConfirm();
      }

      if (redirect) {
        location.href = redirect;
      }
    };

  card.appendChild(closeBtn);
  card.appendChild(button);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
}






export function openLoginRegisterPopup(isFlowFromSubscription = false) {

    popupFullscreen({
        type: "info",
        title: LANG().stripe_user_data.user_data,
        subtitle: LANG().stripe_user_data.create_account,
        content: `
          <style>
            .form-group { margin-bottom: 18px; }
            .form-group label { display: block; font-size: 14px; margin-bottom: 6px; color: #555; font-weight: 500; }
            .form-group input { width: 100%; padding: 14px; border: 1px solid #ddd; border-radius: 10px; font-size: 16px; outline: none; transition: 0.15s; box-sizing: border-box; }
            .form-group input:focus { border-color: #2db1cb; box-shadow: 0 0 0 3px rgba(45,177,203,0.15); }
          </style>

          <img src="https://divantys.com/Views/Default/img/dive_simulator/divantis_logo_horizontal.png" style="width:100%; margin:0 auto;">
          <br><br>

          <form id="user-data-form" autocomplete="on">
            <div class="form-group">
              <label for="username">${LANG().stripe_user_data.username}</label>
              <input type="text" id="username" name="username" placeholder="${LANG().stripe_user_data.enter_username}" autocomplete="username" required>
            </div>
            <div class="form-group">
              <label for="email">${LANG().stripe_user_data.email_user}</label>
              <input type="email" id="email" name="email" placeholder="${LANG().stripe_user_data.enter_email}" autocomplete="email" required>
            </div>
            <div class="form-group">
              <label for="password">${LANG().stripe_user_data.password}</label>
              <input type="password" id="password" name="password" placeholder="${LANG().stripe_user_data.enter_password}" autocomplete="new-password" required>
            </div>
            <div class="form-group">
              <label for="password_repeat">${LANG().stripe_user_data.repeat_password}</label>
              <input type="password" id="password_repeat" name="password_repeat" placeholder="${LANG().stripe_user_data.enter_repeat_password}" autocomplete="new-password" required>
            </div>
          </form>
        `,
        showButtons: true,
        cancelText: LANG().payment_stripe.cancelar || "Cancelar",
        continueText: LANG().payment_stripe.continuar,
        onCancel: () => { console.log("usuario canceló el registro"); },
        onContinue: async () => {
            const username = document.getElementById("username").value.trim();
            const email = document.getElementById("email").value.trim();
            const password = document.getElementById("password").value;
            const repeat = document.getElementById("password_repeat").value;

            if (!username || !email || !password || !repeat) {
                alertas({ type: "error", title: LANG().payment_stripe.error, message: LANG().payment_stripe.completa_inputs, buttonText: LANG().payment_stripe.close });
                return;
            }
            if (password !== repeat) {
                alertas({ type: "error", title: LANG().payment_stripe.error_passwords, message: LANG().payment_stripe.passwords_no_iguales, buttonText: LANG().payment_stripe.close });
                return;
            }
            if (!ValidateEmail(email)) {
                alertas({ type: "error", title: LANG().payment_stripe.error_email, message: LANG().payment_stripe.ingresa_email_valido, buttonText: LANG().payment_stripe.close });
                return;
            }

            // Almacenar datos temporalmente en LocalStorage para usarse en los pasos siguientes
           localStorage.setItem("username", username);
            localStorage.setItem("email", email);
            localStorage.setItem("password", password);
            //localStorage.setItem("key_payment", random_keys());

            console.log("Iniciando alta de usuario en el servidor local...");

            // 🔥 Llamamos a la función y desestructuramos la respuesta
            const resultado = await alta_reserva_localstorage("pending");

            if (!resultado.success) {
                // 1. Si el usuario ya existe
                if (resultado.error === "USER_ALREADY_EXISTS") {
                    alertas({
                        type: "warning",
                        title: LANG().payment_stripe.cuenta_existente,
                        message: LANG().payment_stripe.cuenta_existente_txt,
                        buttonText: "OK"
                    });
                    return;
                }
                
                // 2. Si el servidor se rompió (Error 500, HTML devuelto en vez de JSON)
                if (resultado.error === "SERVER_ERROR") {
                    alertas({
                        type: "error",
                        title: "Server Error",
                        message: resultado.message // Muestra el texto plano devuelto por PHP
                    });
                    return;
                }

                // 3. Cualquier otro error controlado que venga de tu PHP (ej: datos inválidos)
                alertas({
                    type: "error",
                    title: LANG().payment_stripe.error || "Error",
                    message: resultado.message, // Mensaje amigable enviado por el servidor
                    buttonText: LANG().payment_stripe.close
                });
                return;
            }

            // ==========================================
            // SI TODO SALIÓ BIEN (resultado.success === true)
            // ==========================================
            

            alertas({
                type: "success",
                title: LANG().index.registro_existoso,
                message: LANG().index.instrucciones_email_registro,
                buttonText: LANG().index.continuar,
                onConfirm: () => {
                    location.reload(); 
                }
            });

            const old = document.getElementById("iosFullscreenOverlay");
            if (old) old.remove();



            const userData = { username, email }; // No incluimos password porque ya se borró por seguridad
            console.log("Usuario listo para continuar:", userData);


        }
    });
}





export function openLegalPopup(){
  popupFullscreen({
    title: "Legal",
    content: LANG().condiciones.full,
    buttons: [
      {
        text: "Continuar",
        id: "btn_accept_legal"
      }
    ]
  });

  setTimeout(()=>{
    activateLegalScroll();
  },50);
}





function activateLegalScroll(){
  const box = document.getElementById("legal_scroll_container");
  const btn = document.getElementById("legal_continue_btn");

  if(!box || !btn) return;

  btn.addEventListener("click",()=>{
    // Al aceptar los términos legales del flujo de compra, abrimos el registro indicando que vaya en cadena.
    openLoginRegisterPopup(true);
  });
}


export function popupFullscreen({
  type = "info",        // info | success | warning | error
  title = "Título",
  subtitle = "",
  content = "",

  // botones
  showButtons = false,

  cancelText = "Cancelar",
  continueText = "Continuar",

  onCancel = null,
  onContinue = null,

  redirectCancel = null,
  redirectContinue = null

}) {

  // eliminar popup previo
  const old = document.getElementById("iosFullscreenOverlay");
  if (old) old.remove();


  // colores
  const COLORS = {
    info:    "#2db1cb",
    success: "#34C759",
    warning: "#FF9F0A",
    error:   "#FF3B30"
  };

  const BTN_COLOR = COLORS[type] || COLORS.info;


  // insertar estilos una sola vez
  if (!document.getElementById("iosFullscreenStyle")) {

    const style = document.createElement("style");
    style.id = "iosFullscreenStyle";

    style.innerHTML = `

      #iosFullscreenOverlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.45);
        backdrop-filter: blur(10px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999999;
        animation: fadeIn 0.25s ease;
      }

      #iosFullscreenCard {
        position: relative;
        width: 94%;
        height:90%;
        max-width: 700px;
        background: #fff;
        display: flex;
        flex-direction: column;
        font-family:
        -apple-system,
        BlinkMacSystemFont,
        "Segoe UI",
        Roboto;
        animation: slideUp 0.25s ease;
      }

      .iosFullscreenHeader {
        padding: 20px 20px 10px 20px;
        border-bottom: 1px solid #eee;
      }

      .iosFullscreenHeader h2 {
        margin: 0;
        font-size: 22px;
        font-weight: 600;
        color: #111;
      }

      .iosFullscreenHeader h3 {
        margin: 6px 0 0 0;
        font-size: 15px;
        font-weight: 400;
        color: #666;
      }

      .iosFullscreenContent {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
        font-size: 16px;
        color: #333;
        line-height: 1.5;
      }

      .iosFullscreenFooter {
        padding: 15px 20px;
        border-top: 1px solid #eee;
        display: flex;
        gap: 10px;
      }

      .iosFullscreenBtn {
        flex: 1;
        padding: 14px;
        border: none;
        font-size: 17px;
        font-weight: 500;
        color: #fff;
        cursor: pointer;
      }

      .iosFullscreenBtnCancel {
        background: #ccc;
        color: #333;
      }

      .iosFullscreenClose {
        position: absolute;
        top: 14px;
        right: 14px;
        width: 32px;
        height: 32px;
        background: rgb(251 21 21 / 74%);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
      }

      .iosFullscreenClose:hover {
        background: rgba(0,0,0,0.15);
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideUp {
        from {
          transform: translateY(40px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }

    `;

    document.head.appendChild(style);
  }


  // overlay
  const overlay = document.createElement("div");
  overlay.id = "iosFullscreenOverlay";


  // card
  const card = document.createElement("div");
  card.id = "iosFullscreenCard";


  // close icon
  const close = document.createElement("div");
  close.className = "iosFullscreenClose";
  close.innerHTML = "✕";

  close.onclick = () => {

    overlay.remove();

    if (typeof onCancel === "function") {
      onCancel();
    }

    if (redirectCancel) {
      location.href = redirectCancel;
    }

  };


  // header
  const header = document.createElement("div");
  header.className = "iosFullscreenHeader";

  header.innerHTML = `
    <h2>${title}</h2>
    ${subtitle ? `<h3>${subtitle}</h3>` : ""}
  `;


  // body
  const body = document.createElement("div");
  body.className = "iosFullscreenContent";
  body.innerHTML = content;


  card.appendChild(close);
  card.appendChild(header);
  card.appendChild(body);


  // FOOTER con botones
  if (showButtons) {

    const footer = document.createElement("div");
    footer.className = "iosFullscreenFooter";


    // CANCELAR
    const cancelBtn = document.createElement("button");
    cancelBtn.className = "iosFullscreenBtn iosFullscreenBtnCancel";
    cancelBtn.innerText = cancelText;

    cancelBtn.onclick = () => {

      overlay.remove();

      if (typeof onCancel === "function") {
        onCancel();
      }

      if (redirectCancel) {
        location.href = redirectCancel;
      }

    };


    // CONTINUAR
    const continueBtn = document.createElement("button");
    continueBtn.className = "iosFullscreenBtn";
    continueBtn.style.background = "linear-gradient(180deg, var(--accent), rgba(85, 240, 201, 0.92))";
    continueBtn.style.color = "#333333";
    continueBtn.style.boxShadow = "0 20px 50px rgba(46, 215, 255, 0.18)";
    continueBtn.innerText = continueText;

    continueBtn.onclick = () => {

      //overlay.remove();

      if (typeof onContinue === "function") {
        onContinue();
      }

      if (redirectContinue) {
        location.href = redirectContinue;
      }

    };

    footer.appendChild(cancelBtn);
    footer.appendChild(continueBtn);

    card.appendChild(footer);
  }


  overlay.appendChild(card);
  document.body.appendChild(overlay);


  // sonido opcional
  if (typeof playSound === "function") {
    playSound(type);
  }

}















export function login() {


  // eliminar popup previo
  const old = document.getElementById("loginOverlay");
  if (old) old.remove();


  // insertar estilos una sola vez
  if (!document.getElementById("loginStyle")) {

    const style = document.createElement("style");
    style.id = "loginStyle";

    style.innerHTML = `

      #loginOverlay{
        position:fixed;
        inset:0;
        background:rgba(0,0,0,0.45);
        backdrop-filter:blur(10px);
        display:flex;
        justify-content:center;
        align-items:center;
        z-index:999999;
        animation:fadeIn .25s ease;
      }

      #loginCard{
        width:94%;
        height:92%;
        max-width:500px;
        background:#fff;
        display:flex;
        flex-direction:column;
        position:relative;
        font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto;
        animation:slideUp .25s ease;
      color: #333333;
      }

      .loginClose{
        position:absolute;
        top:12px;
        right:12px;
        width:32px;
        height:32px;
        border-radius:50%;
        background:rgb(225 74 74);
        display:flex;
        justify-content:center;
        align-items:center;
        cursor:pointer;
        font-size:18px;
      color:#ffffff;
      }

      .loginHeader{
        padding:20px;
        border-bottom:1px solid #eee;
      }

      .loginHeader h2{
        margin:0;
        font-size:22px;
      }

      .loginHeader h3{
        margin:5px 0 0;
        font-weight:400;
        color:#666;
        font-size:15px;
      }

      .loginBody{
        flex:1;
        padding:25px;
      }

      .loginField{
        width:100%;
        padding:14px;
        margin-bottom:12px;
        border-radius:10px;
        border:1px solid #ddd;
        font-size:16px;
      }

      .loginField:focus{
        border-color:#2db1cb;
        outline:none;
      }

      .loginSubmit{
        width:100%;
        padding:15px;
        border:none;
        border-radius:12px;
        background: linear-gradient(180deg, var(--accent), rgba(85, 240, 201, 0.92));
        color: #333333;
        box-shadow: 0 20px 50px rgba(46, 215, 255, 0.18);
        font-size:17px;
        font-weight:600;
        cursor:pointer;
      }

      .loginSubmit:disabled{
        opacity:.6;
      }

      .loginError{
        color:#FF3B30;
        font-size:14px;
        margin-bottom:10px;
        display:none;
      }

      .loginLoader{
        display:none;
        margin-top:10px;
        text-align:center;
        font-size:14px;
        color:#666;
      }

      @keyframes fadeIn{
        from{opacity:0}
        to{opacity:1}
      }

      @keyframes slideUp{
        from{transform:translateY(40px);opacity:0}
        to{transform:translateY(0);opacity:1}
      }

    `;

    document.head.appendChild(style);
  }


  // crear popup
  const overlay = document.createElement("div");
  overlay.id = "loginOverlay";

  overlay.innerHTML = `

    <div id="loginCard">

      <div class="loginClose" id="loginClose">✕</div>

      <div class="loginHeader">
        <h2>${LANG().login.iniciar_session}</h2>
        <h3>${LANG().login.accede_a_cuenta}</h3>
      </div>

      <div class="loginBody">

     <img src="https://divantys.com/Views/Default/img/dive_simulator/divantis_logo_horizontal.png" style="width:100%; margin:0 auto;">
          <br><br>



        <form id="loginForm">

          <input
            type="email"
            id="loginEmail"
            class="loginField"
            placeholder="${LANG().login.email}"
            required
          >

          <input
            type="password"
            id="loginPassword"
            class="loginField"
            placeholder="${LANG().login.password}"
            required
          >

          <div id="loginError" class="loginError"></div>

          <button
            type="submit"
            id="loginSubmit"
            class="loginSubmit"
          >
            ${LANG().login.iniciar_session_btn}
          </button>

          <div id="loginLoader" class="loginLoader">
            ${LANG().login.verificando}
          </div>

        </form>

          <br>
    <hr>

          <button type="button" class="loginSubmit"  onclick="viewForgot()">
            Forgot password
          </button>


      </div>

    </div>

  `;

  document.body.appendChild(overlay);


  // cerrar popup
  document.getElementById("loginClose").onclick = () => {
    overlay.remove();
  };


  // submit login
  document.getElementById("loginForm").onsubmit = async (e) => {

    e.preventDefault();




    const email = document.getElementById("loginEmail").value.trim();
    const password = document.getElementById("loginPassword").value.trim();


            if (!email || !password) {

                    alertas({
                      type: "error",
                      title: LANG().payment_stripe.error,
                      message: LANG().payment_stripe.completa_inputs,
                      buttonText: LANG().payment_stripe.close
                    });
                    return;

            }

             if (!ValidateEmail(email)) {

                    alertas({
                          type: "error",
                          title: LANG().payment_stripe.error_email,
                          message: LANG().payment_stripe.ingresa_email_valido,
                          buttonText: LANG().payment_stripe.close
                        });
                    return;
                
            }




    const btn = document.getElementById("loginSubmit");
    const loader = document.getElementById("loginLoader");
    const error = document.getElementById("loginError");

    error.style.display = "none";
    loader.style.display = "block";
    btn.disabled = true;

    try {

      const res = await fetch("https://divantys.com/Index/login", {

        method:"POST",
        headers:{
          "Content-Type":"application/json"
        },
        body: JSON.stringify({
          email,
          password
        })

      });

      const data = await res.json();

         console.log(JSON.stringify(data))

      if (!data.success) {
        throw new Error(data.message || LANG().login.credenciales_incorrectas);
      }


      if(data.success == 1){

        overlay.remove();
        window.location.href = "https://divantys.com/Index/dashboard";
        //location.reload();

      }else if(data.success == 0){

           alertas({
              type: "error",
              title: LANG().payment_stripe.error,
              message: "Credenciales Invalidas",
              buttonText: LANG().payment_stripe.close
            });
            return;


      }else if(data.success == 2){

           alertas({
              type: "error",
              title: LANG().payment_stripe.error,
              message: "Password Invalido",
              buttonText: LANG().payment_stripe.close
            });
            return;


      }else if(data.success == 3){


           alertas({
              type: "error",
              title: LANG().payment_stripe.error,
              message: "Hay otra sesión abierta. ¿Deseas establecerla en este dispositivo?",
              buttonText: "Sí, continuar",
              onConfirm: () => {

                fetch("https://divantys.com/Index/force_login", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  body: "user_id=" + data.user_id   // 👈 el id que te devolvió login
                })
                .then(r => r.json())
                .then(data => {

                  if(data.success === 1){

                    window.location.href = "https://divantys.com/Index/dashboard";

                  }

                });

              }
            });
            return;


      }

      
      

   

    }
    catch(err){

      error.innerText = err.message;
      error.style.display = "block";

    }
    finally{

      loader.style.display = "none";
      btn.disabled = false;

    }

  };

}







export function viewForgot(){

  const overlay = document.getElementById("loginCard");

  overlay.innerHTML = `

     <div class="loginClose" id="loginClose">✕</div>

      <div class="loginHeader">

      <div style="text-align:left">
        <a onclick="login()">◀ Back</a>
      </div>

        <h2>Recuperar Password</h2>
      </div>

      <div class="loginBody">

    <form id="forgotForm">

          <input
            type="email"
            name="email"
            id="recoveryEmail"
            class="loginField"
            placeholder="${LANG().login.email}"
            required
          >

          <div id="loginError" class="loginError"></div>

          <button onclick="forgotPassword(this.form, this)"
            type="button"
            class="loginSubmit"
          >
            Enviar Email
          </button>
    </form>

    <p id="forgotMsg" class="small-text"></p>


`;
}











// ===============================
// COOKIES & PERMISSIONS MODULE (REQUIRED)
// ===============================

export function cookiesConsent() {

  const STORAGE_KEY = "site_cookie_consent_v1";

  // evitar duplicado
  if (document.getElementById("cookiesOverlay")) return;

  const existing = localStorage.getItem(STORAGE_KEY);

  // Si ya aceptó → permitir sitio
  if (existing === "accepted") {
    window.__cookieConsent = { accepted: true };
    return;
  }

  // 🔒 BLOQUEAR SCROLL TOTAL
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";

  // estilos (los tuyos intactos)
  if (!document.getElementById("cookiesStyle")) {

    const style = document.createElement("style");
    style.id = "cookiesStyle";

    style.innerHTML = `
      #cookiesOverlay{
        position:fixed;
        inset:0;
        background:rgba(0,0,0,0.35);
        backdrop-filter:blur(6px);
        display:flex;
        justify-content:center;
        align-items:flex-end;
        z-index:2147483647;
        animation:fadeIn .25s ease;
      }

      #cookiesCard{
        width:100%;
        max-width:700px;
        background:#fff;
        border-radius:22px 22px 0 0;
        padding:25px;
        font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto;
        animation:slideUp .3s ease;
        margin:10px 10px 0px 10px;
      color: #333333;
      }

      .cookiesTitle{
        font-size:20px;
        font-weight:600;
        margin-bottom:10px;
      }

      .cookiesText{
        font-size:15px;
        color:#444;
        line-height:1.5;
      }

      .cookiesBtns{
        display:flex;
        gap:10px;
        margin-top:20px;
      }

      .cookiesBtn{
        flex:1;
        padding:14px;
        border:none;
        border-radius:14px;
        font-size:15px;
        font-weight:500;
        cursor:pointer;
      }

      .cookiesAccept{
                border: 1px solid rgb(0 36 255);
                border-radius: 12px;
                background: rgb(0 163 255 / 36%);
      }

      .cookiesReject{
        border: 1px solid rgb(255 0 0);
        border-radius: 12px;
        background: rgb(255 0 0 / 36%);
      }

      @keyframes fadeIn{
        from{opacity:0}
        to{opacity:1}
      }

      @keyframes slideUp{
        from{transform:translateY(100%);opacity:0}
        to{transform:translateY(0);opacity:1}
      }

      @media(max-width:600px){
        .cookiesBtns{
          flex-direction:column;
        }
      }
    `;

    document.head.appendChild(style);
  }

  const overlay = document.createElement("div");
  overlay.id = "cookiesOverlay";

  overlay.innerHTML = `
    <div id="cookiesCard">

      <div class="cookiesTitle">
        🍪 ${LANG().cookies.title}
      </div>

      <div class="cookiesText">
        ${LANG().cookies.message}
      </div>

      <div class="cookiesBtns">


        <button class="cookiesBtn cookiesAccept" id="cookiesAccept">
          ${LANG().cookies.accept}
        </button>



        <button class="cookiesBtn cookiesReject" id="cookiesReject">
          ${LANG().cookies.reject}
        </button>

        

      </div>

    </div>
  `;

  document.body.appendChild(overlay);


  function saveConsent(value){

    localStorage.setItem(STORAGE_KEY, value);

    // también guardarlo como cookie real
    document.cookie = `
      cookie_consent=${value};
      path=/;
      max-age=31536000;
      SameSite=Lax
    `;

    window.__cookieConsent = { accepted: value === "accepted" };
  }


  // ✅ ACEPTAR
  document.getElementById("cookiesAccept").onclick = () => {

    saveConsent("accepted");

    overlay.remove();

    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };


  // ❌ RECHAZAR → BLOQUEAR SITIO
  document.getElementById("cookiesReject").onclick = () => {

    saveConsent("rejected");

    document.body.innerHTML = `
      <div style="
        display:flex;
        justify-content:center;
        align-items:center;
        height:100vh;
        text-align:center;
        font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto;
      ">
        <div>
          <h2>${LANG().cookies.acceso_denegado}</h2>
          <p>${LANG().cookies.debes_aceptar}</p>
        </div>
      </div>
    `;
  };

}




window.viewForgot = viewForgot;
window.forgotPassword = forgotPassword;